import {   
REQUEST_COMPANIES,
RECEIVE_COMPANIES_SUCCESS,
RECEIVE_COMPANIES_ERROR,
REQUEST_COMPANY_SAVE,
RECEIVE_COMPANY_SAVE_SUCCESS,
RECEIVE_COMPANY_SAVE_ERROR,
REQUEST_COMPANY_CREATE,
RECEIVE_COMPANY_CREATE_SUCCESS,
RECEIVE_COMPANY_CREATE_ERROR

        }  from '../actions/company'




const DEFAULT_COMPANIES =   {
    isFetching: false,
    companies: []
    };



export function companies(state = DEFAULT_COMPANIES, action) {
    
    switch (action.type) {
        case REQUEST_COMPANIES: {
            var newstate = {
                companies: [...state.companies],             
                isFetching: true
            };
            return newstate;
        }
        case RECEIVE_COMPANIES_SUCCESS: {
            var newstate = {
                ...state,   
                companies: [...action.companies],
                isFetching: false
                 }

            return newstate;            
        }

        case REQUEST_COMPANY_SAVE: {

            let index = state.companies.findIndex(x => x.id === action.company.id);
            if (index < 0) 
                break;
            let newState = 
                {...state,
                    companies: [...state.companies],
                    isFetching: true}    
                newState.companies[index] =  {
                        ...state.companies[index], 
                        isFetching: true};                    
            return newState;
        }

        case REQUEST_COMPANY_CREATE: {

            let newState = 
                {...state,
                    companies: [...state.companies],
                    isFetching: true}    
            return newState;
        }

        case RECEIVE_COMPANY_CREATE_SUCCESS: {
            let newState = 
                {...state,
                    companies: [...state.companies, action.company],
                    isFetching: false}    
            return newState;
        }


        case RECEIVE_COMPANY_SAVE_SUCCESS: {
            let ind = state.companies.findIndex(x => x.id === action.company.id);
            if (ind < 0) 
                break;
            let newState = 
                {...state,
                    companies: [...state.companies],
                    isFetching: false}    
                newState.companies[ind] =  {
                        ...action.company, 
                        isFetching: false};                    
            return newState;

        }
        
        
        default: {
            return state;
        }
    }
}
